import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class UpdateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: {}
        };
    }

    componentDidMount() {
        this.setState({ item: this.props.item });
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        if(!fields.title){
            formIsValid = false;
            errors.title = "The title field is required.";
        }

        if(!fields.url){
            formIsValid = false;
            errors.url = "The destination url field is required.";
        }
        if(fields.url && !(fields.url).match(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g))
        {
            formIsValid = false;
            errors.url = "Please enter valid destination url.";
        }
        
        this.setState({errors: errors});
        return formIsValid;
    }

    update = e => {
        e.preventDefault();
        if(this.handleValidation()){
            this.props
            .update(this.props.item.id, this.state.item)
            .then(response => {
                this.props.hideUpdate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
        }        
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Update record</h2>
                    <div className="model-content">
                        <form onSubmit={this.update}>                            
                            <div className="form-group">
                                <label htmlFor="name">Title</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    value={this.state.item.title}
                                    id="title"
                                    name="title"
                                    placeholder="Enter title"
                                ></input>
                                {this.state.errors.title ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.title}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="Destination URL">Destination URL</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="url"
                                    className="form-control"
                                    id="url"
                                    name="url"
                                    value={this.state.item.url}
                                    placeholder="Enter url"
                                ></input>
                                {this.state.errors.url ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.url}
                                    </div>
                                ) : null}
                            </div>
                            <button
                                type="button"
                                onClick={this.update}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideUpdate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
UpdateModel.contextType = AppContext;
export default UpdateModel;



// WEBPACK FOOTER //
// ./src/components/admin/writerTips/UpdateModel.js